import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';
import { DocumentLibraryConstants } from '../document-library-constants';
import { CheckOutDTO } from '../models/checkout-DTO';
import { DocumentDetail } from '../models/documentVersionDetail';
import { DocumentService } from '../services/document.service';

@Component({
  selector: 'app-document-check-out',
  templateUrl: './document-check-out.component.html',
  styleUrls: ['./document-check-out.component.scss']
})
export class DocumentCheckOutComponent implements OnInit {
  @Input() documentDetail!: DocumentDetail;
  @Output() isDocumentCheckoutSuccessful = new EventEmitter<boolean>();
  checkOutInformation!:CheckOutDTO;

  constructor( private documentsservice: DocumentService, 
    private messageService: MessageService,) { }

  ngOnInit(): void {
  }

  fileCheckedOut() { 
    this.checkOutInformation={
      checkedOutUser:this.documentDetail.loggedInUser,
      checkOutTime:new Date()
    }
    this.documentsservice.updateDocumentCheckoutInfo(this.documentDetail.number,this.documentDetail.version,this.checkOutInformation)
    .pipe(
      catchError((err) => {
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Err,
          summary: `${err.error}`,
        });
        return throwError(() => err);
      })
    )
    .subscribe((serviceData) => {
      this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Warning,
        summary: `${DocumentLibraryConstants.FileCheckOutToasterMessage}`,
      });
      this.isDocumentCheckoutSuccessful.emit(true);    
    });
  }
}
